import React, { Component } from 'react';
import PropType from 'prop-types';
import { Label } from 'react-bootstrap';
import * as _ from 'lodash';

import { deepEqual } from './../../utils';

import './styles.css';

class VehicleCell extends Component {
  shouldComponentUpdate(nextProps) {
    return !deepEqual(this.extractUsedProps(this.props), this.extractUsedProps(nextProps));
  }

  extractUsedProps(props = {}) {
    return _.pick((props.vehicle || this.props.vehicle), [
      'plate',
      'manufYear',
      'modelYear',
      'model',
      'brand',
    ]);
  }

  render() {
    const props = this.extractUsedProps(this.props);

    return (
      <div className="vehicle-wrapper">
        <div className="secondary" style={{ marginTop: 0, marginBottom: '6px' }}>
          <small>{props.brand} - {props.model}</small>
        </div>
        <div className="primary">
          <Label
            bsStyle="default"
            style={{ fontSize: '89%' }}
          >
            {props.plate}
          </Label>
          {'  '}
        </div>
        <div className="secondary">
          <small>{props.manufYear}/{props.modelYear}</small>
        </div>
      </div>
    );
  }
}

VehicleCell.propTypes = {
  vehicle: PropType.object.isRequired,
};

export default VehicleCell;



// WEBPACK FOOTER //
// ./src/Vehicle/VehicleCell/index.js